var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-orange",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34593",
    "data-name": "Path 34593",
    d: "M16.4,4H11.6C7.07,4,4.807,4,3.4,5.371c-1.012.987-1.3,2.407-1.375,4.772h23.94c-.079-2.365-.363-3.785-1.375-4.772C23.184,4,20.922,4,16.4,4Z",
    transform: "translate(0.004)",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34594",
    "data-name": "Path 34594",
    d: "M11.6,21.573h4.8c4.525,0,6.788,0,8.194-1.371S26,16.625,26,12.213q0-.776,0-1.463H2q0,.688,0,1.463c0,4.413,0,6.619,1.406,7.99S7.075,21.573,11.6,21.573Z",
    transform: "translate(0 0.427)",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34595",
    "data-name": "Path 34595",
    d: "M5.25,16.128a.878.878,0,0,1,.878-.878h4.68a.878.878,0,0,1,0,1.755H6.128A.878.878,0,0,1,5.25,16.128Z",
    transform: "translate(0.687 1.354)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34596",
    "data-name": "Path 34596",
    d: "M11.75,16.128a.878.878,0,0,1,.878-.878h1.755a.878.878,0,0,1,0,1.755H12.628A.878.878,0,0,1,11.75,16.128Z",
    transform: "translate(2.002 1.354)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOrange);
export default __webpack_public_path__ + "static/media/card-orange.d84d452b1bd97ce8d0aa532b9203d0b1.svg";
export { ForwardRef as ReactComponent };